module.exports = __webpack_public_path__ + "static/media/SQ.2732d8b7.png";